/**
 * Maxi — inicia no slide de vídeo uma única vez.
 * NÃO reinicia em troca de variante.
 * NÃO clica no <a> do thumbnail sem proteção (isso recarregava/navegava a página).
 */
(function () {
  'use strict';

  var startedGalleries = new WeakSet();

  function pauseOtherVideos(exceptItem) {
    document.querySelectorAll('.product-gallery__carousel-item[data-media-type="video"] video, .product-gallery__carousel-item[data-media-type="external_video"] iframe').forEach(function (el) {
      var item = el.closest('.product-gallery__carousel-item');
      if (exceptItem && item === exceptItem) return;
      if (el.tagName === 'VIDEO') {
        try {
          el.pause();
        } catch (e) {}
      }
    });
  }

  function safeSelectThumbnail(gallery, videoId) {
    var thumb = gallery.querySelector('.product-gallery__thumbnail[data-media-id="' + videoId + '"]');
    if (!thumb) return false;

    // Evita navegação para a URL da imagem (causa "reload" da PDP)
    var href = thumb.getAttribute('href');
    if (href) {
      thumb.setAttribute('data-maxi-href', href);
      thumb.removeAttribute('href');
    }

    try {
      thumb.dispatchEvent(
        new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
      );
    } catch (e) {
      thumb.click();
    }

    if (href) {
      window.setTimeout(function () {
        if (!thumb.getAttribute('href')) {
          thumb.setAttribute('href', href);
        }
        thumb.removeAttribute('data-maxi-href');
      }, 0);
    }

    return true;
  }

  function startGallery(gallery) {
    if (!gallery || startedGalleries.has(gallery) || gallery.dataset.maxiVideoStarted === 'true') {
      return;
    }

    var videoId = gallery.getAttribute('data-video-media-id');
    if (!videoId) return;

    var item = gallery.querySelector(
      '.product-gallery__carousel-item[data-media-id="' + videoId + '"]'
    );
    if (!item) return;

    startedGalleries.add(gallery);
    gallery.dataset.maxiVideoStarted = 'true';

    // Se já está no vídeo (Liquid já marcou is-selected), só garante pause nos outros
    if (item.classList.contains('is-selected')) {
      pauseOtherVideos(item);
      return;
    }

    // Aguarda o ProductGallery do tema inicializar antes de selecionar
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;

      if (item.classList.contains('is-selected')) {
        pauseOtherVideos(item);
        window.clearInterval(timer);
        return;
      }

      // Product section pronta (~após theme.js)
      var sectionReady = gallery.closest('[data-section-type="product"], [data-section-type="product-quick-view"]');
      if (sectionReady && tries >= 3) {
        safeSelectThumbnail(gallery, videoId);
        pauseOtherVideos(item);
        window.clearInterval(timer);
        return;
      }

      if (tries >= 25) {
        window.clearInterval(timer);
      }
    }, 150);
  }

  function boot() {
    document.querySelectorAll('[data-maxi-autoplay-video]').forEach(startGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Uma única tentativa tardia (sem re-disparar play)
  window.addEventListener('load', function () {
    window.setTimeout(boot, 400);
  });

  // Troca de variante: não reinicia vídeo
  document.addEventListener('variant:change', function () {
    document.querySelectorAll('[data-maxi-autoplay-video]').forEach(function (gallery) {
      gallery.dataset.maxiVideoStarted = 'true';
      startedGalleries.add(gallery);
    });
  });
})();
